export default __webpack_public_path__ + "static/reference-b348e53556c458cdd2226c0de0c2f1e1.svg";